module.exports = __webpack_public_path__ + "img/xianyi2.19676663.png";